export const chartColors = {
    // Fixed color constants for ECharts to avoid CSS variable resolution issues in chart configs.
    barGreyStart: '#9e9e9e',
    barGreyEnd: '#6e6e6e',
    barGreyHoverStart: '#bdbdbd',
    barGreyHoverEnd: '#848484',
    primaryAccent: '#9747FF',
    primaryAccentDark: '#5B2B99',
    greyStrong: '#8b929c',
};
